module.exports = __webpack_public_path__ + "static/media/closeDeleteIcon.aa36aacd.svg";